import { Component, Input, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { EdiMessageBase, GungEdiAddressInfo, GLNRecord } from '../../../models/edi';
import { EdiService } from '../../../services/edi/edi.service';

interface GungEdiAddressInfoWithData extends GungEdiAddressInfo {
  gln?: number; // This does not exist in the backend but is used in frontend for usability
  title?: string;
  customerId?: string;
  customerName?: string;
}
@Component({
    selector: 'lib-edi-gln-number-tabs',
    templateUrl: './edi-gln-number-tabs.component.html',
    styleUrls: ['./edi-gln-number-tabs.component.css'],
    standalone: false
})
export class EdiGlnNumberTabsComponent implements OnInit {
  glnAddressList: GungEdiAddressInfoWithData[] = [];
  @Input()
  ediMessage: EdiMessageBase;

  constructor(protected ediService: EdiService) {}

  private addToSortedList(item: GungEdiAddressInfoWithData): void {
    this.glnAddressList.push(item);
    this.glnAddressList.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
  }

  protected glnEntries: { glnKey: keyof EdiMessageBase; addressKey: keyof EdiMessageBase; title: string }[] = [
    { glnKey: 'supplierGln', addressKey: 'supplierAddress', title: 'SUPPLIER' },
    { glnKey: 'senderGln', addressKey: 'senderAddress', title: 'SENDER' },
    { glnKey: 'consigneeGln', addressKey: 'consigneeAddress', title: 'CONSIGNEE' },
    { glnKey: 'deliveryGln', addressKey: 'deliveryAddress', title: 'DELIVERY' },
    { glnKey: 'buyerGln', addressKey: 'buyerAddress', title: 'BUYER' },
    { glnKey: 'recipientGln', addressKey: 'recipientAddress', title: 'RECIPIENT' },
    { glnKey: 'invoiceeGln', addressKey: 'invoiceeAddress', title: 'INVOICEE' },
  ];

  ngOnInit(): void {
    for (const { glnKey, addressKey, title } of this.glnEntries) {
      const gln = this.ediMessage[glnKey] as number;
      if (!gln) {
        continue;
      }
      this.ediService.getGLNRecord(gln).pipe(first()).subscribe(glnRecord => {
        const temp = this.ediMessage[addressKey] as GungEdiAddressInfoWithData;
        temp.title = title;
        temp.gln = gln;
        if (!glnRecord) {
          temp.name = 'BLANK';
          temp.customerId = 'BLANK';
          temp.customerName = 'BLANK';
          this.addToSortedList(temp);
          return;
        }
        temp.customerId = glnRecord?.companyId;
        temp.customerName = glnRecord?.b24?.name;
        this.addToSortedList(temp);
      });
    }
  }
}
